module.exports = ".as-action-column {\n  width: 40px; }\n\n.ha-panel-action {\n  position: absolute;\n  right: 15px;\n  top: 5px; }\n"